import { Endpoints, fetch, normalizeKeys } from './api'

/**
 * The plans this caller may open — the backend answers with exactly the set its report gate
 * admits, so an empty array means "entitled to nothing", not "something went wrong".
 */
export const getUserPlansByProductId = async productId => {
  const uri = `${Endpoints.Plan}/${productId}`
  const response = await fetch(uri, { throwOnError: true })
  const plans = normalizeKeys(response.data)

  // Anything but an array would surface as a crash inside the plan picker's render, a long way
  // from the response that caused it.
  if (!Array.isArray(plans)) {
    throw new Error(`Plan/${productId} did not return an array of plans`)
  }

  return plans
}

export const getPlanById = async (productId, planId) => {
  const uri = `${Endpoints.Plan}/${productId}/${planId}`
  const response = await fetch(uri)
  return response.data
}

export const getPlanByName = async (productId, planName) => {
  const encodedPlanName = btoa(planName)
  const uri = `${Endpoints.Plan}/${productId}/${encodedPlanName}`
  const response = await fetch(uri)
  return response.data
}
